import React from 'react';

import styles from '../../TaskTypeField.module.scss';

export interface EventFieldLayoutProps {
  title: string;
  isDeactivated: boolean;
}

export default function EventFieldLayoutWeb(props: EventFieldLayoutProps) {
  const classes = [
    styles.field,
    styles.event,
  ];

  if (props.isDeactivated) {
    classes.push(styles.deactivated);
  }

  return (
    <div className={classes.join(' ')} title={props.title}>&nbsp;</div>
  );
}
